module.exports = __webpack_public_path__ + "static/media/invoice-dialog-checkmark.cb158a81.svg";